/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-29 23:58:22
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-30 11:47:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/tools.ts
 */
import { cloneDeep, get, remove } from 'lodash';
const convertDataFromServer = (d, basicDataOnly?) => {
  const data = cloneDeep(d || {});

  const {
    customerInfo,
    customerInfoFields = [],
    termsConditionsSetting,
    termsConditionsList = [],
    commentBox,
    promotionBar,
    guestCheckout,
    recipientInfo,
    addressLocalisationFormats,
    deliveryAddressSetting,
    crossBorderSetting,
    chinaInvoice,
    china,
    ...rest
  }: any = data;
  const _customerInfo = get(customerInfo, 'fields', []) || [];

  const existingInfoUuid = (customerInfoFields || []).map((i) => i.uuid);
  if (!basicDataOnly) {
    remove(_customerInfo, (x: any) => {
      const uuid = get(x, 'field.uuid');
      return !existingInfoUuid.includes(uuid);
    });
  }

  const _recipientInfo = get(recipientInfo, 'fields', []);

  const destinations = get(deliveryAddressSetting, 'destinations', []) || [];

  const existingDesoUuid = (addressLocalisationFormats || []).map(
    (i) => i.uuid,
  );
  if (!basicDataOnly) {
    remove(destinations, (x: any) => {
      const uuid = get(x, 'format.uuid');
      return !existingDesoUuid.includes(uuid);
    });
  }

  const _crossBorderSetting = get(crossBorderSetting, 'destinations', []) || [];

  const _termConditions =
    get(termsConditionsSetting, 'termsConditions', []) || [];
  return {
    customerInfo: _customerInfo,
    recipientInfo: _recipientInfo,
    crossBorderSetting: _crossBorderSetting,
    termConditions: _termConditions,
    addressLocalisationFormats,
    destinations,
    termsConditionsList,
    commentBox,
    promotionBar,
    guestCheckout,
    customerInfoFields,
    chinaInvoice,
    isChina: china,
    ...rest,
  };
};

export { convertDataFromServer };
